import { zodResolver } from '@hookform/resolvers/zod'
import { Typography } from '@material-ui/core'
import { useCallback, useState } from 'react'
import { useForm } from 'react-hook-form'
import { z } from 'zod'

import Button from '@/components/button'
import InputText from '@/components/input-text'
import { useCreateFolder } from '@/hooks/mutations/use-create-folder'

import { Message } from './message'
import { useStyles } from './styles'

interface FormProps {
  handleClose: () => void
}

const formSchema = z.object({
  name: z.string().min(1, 'O campo é obrigatório'),
  description: z.string().min(1, 'O campo é obrigatório'),
})

export const Form = ({ handleClose }: FormProps) => {
  const classes = useStyles()
  const [errorMessage, setErrorMessage] = useState<{
    title: string
    message: string
  }>()

  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm({
    defaultValues: {
      name: '',
      description: '',
    },
    resolver: zodResolver(formSchema),
  })

  const handleErrorMessage = useCallback(setErrorMessage, [])
  const { isError, isLoading, isSuccess, mutateAsync } =
    useCreateFolder(handleErrorMessage)

  if (isError) {
    return (
      <Message title={errorMessage?.title} message={errorMessage?.message} />
    )
  }

  if (isSuccess) {
    return (
      <Message title='Pasta adicionada'>
        <Typography>Sua pasta foi adicionada,</Typography>
        <Typography>
          adicione diagnósticos para conseguir visualizá-los
        </Typography>
      </Message>
    )
  }

  return (
    <form
      className={classes.form}
      onSubmit={handleSubmit((data) => mutateAsync(data))}
    >
      <Typography variant='h4' className={classes.title}>
        Adicionar pasta
      </Typography>
      <InputText
        className={classes.input}
        id='name-input'
        label='Nome da pasta'
        size='small'
        error={Boolean(errors.name)}
        helperText={errors.name?.message}
        {...register('name')}
      />
      <InputText
        className={classes.input}
        id='description-input'
        label='Descrição'
        size='small'
        minRows={3}
        multiline
        error={Boolean(errors.description)}
        helperText={errors.description?.message}
        {...register('description')}
      />
      <div className={classes.buttons}>
        <Button labelOnly onClick={handleClose}>
          Cancelar
        </Button>
        <Button loading={isLoading} type='submit'>
          Adicionar
        </Button>
      </div>
    </form>
  )
}
